import React, {useEffect, useState} from 'react';
import pauseImg from '../../assets/img/ic-pause.svg'
import playImg from '../../assets/img/ic-pause-play.png'
import playForward from '../../assets/img/ic-player-forward.svg'
import playBack from '../../assets/img/ic-player-back.svg'
import Audio from '../form/Audio/Audio'
import Progress from "./util/progress";
import {dataService} from "../../services/dataService";
import Util from "../../utils/utils";
import * as config from '../../config'
import "video.js/dist/video-js.css";
import VideoJS from "../form/Video/VideoJs";
import ModalVideo from 'react-modal-video'
import $ from 'jquery'

let client;
let progressInterval;

const Footer = () => {
    const token = Util.getSession("token");
    const square_ref = React.createRef();
    let [audio] = useState(Audio);
    const [isPlaying, setIsPlaying] = useState(false);
    const [duration, setDuration] = useState(0);
    const [mediaRate, setMediaRate] = useState(1);
    const [volumeStatus, setVolumeStatus] = useState(true);
    const [currentTime, setCurrentTime] = useState(0);
    const [state, setState] = useState({
        name: "",
        url: "",
        item_id: 0,
        item_type: 0,
        knob: 0,
        video_full_screen: false,
        videoJsOptions: {
            autoplay: true,
            controls: false,
            responsive: true,
            isFullscreen: false,
            fluid: true,
            playbackRates: [1, 1.25, 1.5, 1.75, 2],
            sources: [{
                src: "",
                type: 'video/mp4'
            }]
        }
    });

    const playerRef = React.useRef(null);

    useEffect(() => {
        try {
            if (mediaRate) {
                if (state.item_type === 0) {
                    audio.playbackRate = mediaRate;
                } else {
                    if (!playerRef.current) {
                        return;
                    }

                    playerRef.current.playbackRate(mediaRate);
                }
            }
        } catch (e) {
            console.log("Error: ", e)
        }
    }, [mediaRate]);

    useEffect(() => {
        try {
            if (volumeStatus) {
                if (state.item_type === 0) {
                    audio.volume = 1;
                } else {
                    if (!playerRef.current) {
                        return;
                    }

                    playerRef.current.volume(1);
                }
            } else {
                if (state.item_type === 0) {
                    audio.volume = 0;
                } else {
                    if (!playerRef.current) {
                        return;
                    }

                    playerRef.current.volume(0);
                }
            }
        } catch (e) {
            console.log("Error: ", e)
        }

    }, [volumeStatus]);

    useEffect(() => {
        try {
            if ('mediaSession' in navigator) {
                navigator.mediaSession.setActionHandler('play', function () {
                    setIsPlaying(true);
                });
                navigator.mediaSession.setActionHandler('pause', function () {
                    setIsPlaying(false);
                });
            }
        } catch (e) {
            console.log("Error: " + e)
        }
    }, []);

    useEffect(() => {
            playMedia()
        },
        [isPlaying]
    );

    useEffect(() => {
        try {
            dataService.getData().subscribe(message => {
                let data = message.value;

                if (data.progressValue) {
                    // closeSocket();
                    //
                    // openSocket().then( ( client ) =>
                    // {
                    // 	console.log(client)
                    // 	console.log(token)
                    // 	sendMessageSocket( client, token );
                    //
                    // } ).catch( ( err ) =>
                    // {
                    // 	console.log(err)
                    // } );
                    // console.log("Asasdasd12321")
                    if (state.item_type === 0) {
                        audio.currentTime = (data.progressValue * audio.duration) / 100;
                    } else if (state.item_type === 1 && playerRef.current) {
                        if (!playerRef.current) {
                            return;
                        }
                        if (!playerRef.current) {
                            return;
                        }

                        playerRef.current.currentTime((data.progressValue * playerRef.current.duration()) / 100)
                    }
                } else {
                    if (data.item_id !== state.item_id) {
                        try {
                            if (audio.src && audio.currentTime) {
                                audio.pause();
                                audio.src = "";
                                audio.currentTime = "";
                            }

                            if (playerRef.current) {
                                playerRef.current.pause();
                                playerRef.current.currentTime(0)
                            }
                        } catch (e) {
                            console.log("Error: ", e)
                        }

                        if (data.action === "edit") {
                            setState((oldState) => ({...oldState, data}));
                        } else {
                            setState(data);
                        }

                        $(".player-rate").val(1).change();

                        updateMedia(data.url, data.item_type);

                        setIsPlaying(true);
                        setMediaRate(1);
                        setVolumeStatus(true);
                        setCurrentTime(data.currentTime);

                        if (data.item_type === 0) {
                            audio.addEventListener('loadedmetadata', () => {
                                audio.currentTime = data.currentTime;
                            });
                        } else {
                            if (!playerRef.current) {
                                return;
                            }

                            playerRef.current.currentTime(data.currentTime);
                        }

                        playMedia(true);

                    }
                }
            });

            if (state.item_type === 0) {
                audio.addEventListener('timeupdate', setCurrentTimeState);

                return () => {
                    audio.removeEventListener('timeupdate', setCurrentTimeState);
                    closeSocket();
                    dataService.getData().unsubscribe();
                };
            }

        } catch (e) {
            console.log("Error: " + e)
        }

    }, []);

    // Cleanup on component unmount
    useEffect(() => {
        return () => {
            closeSocket();
        };
    }, []);

    const playMedia = (setMediaPlay = false) => {
        try {
            if (isPlaying || setMediaPlay) {
                if (state.item_type === 0) {
                    audio.play().then(() => setDuration(Audio.duration));
                } else {
                    if (!playerRef.current) {
                        return;
                    }

                    playerRef.current.play().then(() => setDuration(playerRef.current.duration()));
                }

                openSocket().then((client) => {
                    sendMessageSocket(client, token);
                    
                    if (progressInterval) {
                        clearInterval(progressInterval);
                    }
                    
                    progressInterval = setInterval(() => {
                        if (client && client.readyState === 1) {
                            sendMessageSocket(client, token);
                        }
                    }, 5000);
                }).catch(() => {

                });

                return;
            }

            if (state.item_type === 0) {
                audio.pause();
            } else {
                if (!playerRef.current) {
                    return;
                }

                playerRef.current.pause();
            }

            closeSocket();
        } catch (e) {
            console.log("Error: ", e)
        }
    };

    const handleFullScreen = () => {
        if (playerRef.current) {
            playerRef.current.requestFullscreen();
        }
    };

    const handlePlayerReady = (player) => {
        playerRef.current = player;

        player.on('waiting', () => {
            console.log('player is waiting');
        });

        player.on('timeupdate', () => {
            setCurrentTimeState()
        });

        player.on('ready', () => {
            console.log('player is ready');
            player.play()
        });

        player.on('loadedmetadata', () => {
            console.log("load meta data");
            player.play()
        });

        player.on('dispose', () => {
            console.log('player will dispose');
        });

        player.on('fullscreenchange', () => {
            if (player.isFullscreen()) {
                playerRef.current.controls(true);
                $("#video-player_html5_api").css("height", "100%");
            } else {
                playerRef.current.controls(false);
                $("#video-player_html5_api").css("height", "100px");
            }
        });

    };

    const openSocket = () => {
        return new Promise(function (resolve, reject) {
            if ((client === undefined || (client && client.readyState === 3)) && (state.name !== "" && state.url !== "" && token)) {
                client = new WebSocket(config.ws_url + '/log/');

                client.onopen = () => {
                    console.log('connected');
                    resolve(client);
                };

                client.onmessage = evt => {
                    try {
                        const message = JSON.parse(evt.data);
                        console.log('WebSocket message received:', message);
                        
                        if (message.current_time !== undefined && message.item_id === state.item_id) {
                            const serverTime = parseFloat(message.current_time);
                            let currentTime = 0;
                            
                            if (state.item_type === 0) {
                                currentTime = audio.currentTime;
                            } else if (playerRef.current) {
                                currentTime = playerRef.current.currentTime();
                            }
                            
                            if (Math.abs(serverTime - currentTime) > 5) {
                                if (state.item_type === 0) {
                                    audio.currentTime = serverTime;
                                } else if (playerRef.current) {
                                    playerRef.current.currentTime(serverTime);
                                }
                            }
                        }
                    } catch (e) {
                        console.error('Error parsing WebSocket message:', e);
                    }
                };

                client.onclose = () => {
                    console.log('disconnected')
                };


                client.onerror = function (err) {
                    console.log(err)
                    reject(err);
                };
            } else if (client && client.readyState === 1) {
                console.log("Asdasd")
                // reject(  );
            }

        });
    };

    const closeSocket = () => {
        if (progressInterval) {
            clearInterval(progressInterval);
            progressInterval = null;
        }
        if (client !== undefined && client && client.readyState === 1) {
            client.close();
        }
    };

    const sendMessageSocket = (client) => {
        if (client !== undefined && client && client.readyState === 1) {
            let current_time = 0;
            if (state.item_type === 0) {
                current_time = audio.currentTime;
            } else if (playerRef.current) {
                current_time = playerRef.current.currentTime();
            }
            
            client.send(JSON.stringify({
                "token": token.toString(),
                "item_id": state.item_id,
                "current_time": current_time
            }));
        }
    };

    const setPlaying = (playing) => {
        setIsPlaying(playing);
    };

    const setVolumeStatusState = () => {
        setVolumeStatus(!volumeStatus)
    };

    const setMediaRateState = (value) => {
        setMediaRate(value)
    };

    const setCurrentTimeState = () => {
        let tempCurrentTime = 0;

        if (state.item_type === 0) {
            tempCurrentTime = Audio.currentTime;
        } else {
            if (!playerRef.current) {
                return;
            }

            tempCurrentTime = playerRef.current.currentTime();
        }

        setCurrentTime(tempCurrentTime)
    };

    const toggle = () => {
        setPlaying(!isPlaying);
    };

    const updateMedia = (url, item_type) => {
        if (item_type === 0) {
            audio.src = url;
        } else if (item_type === 1) {
            if (!playerRef.current) {
                return;
            }

            setState((oldState) => ({
                ...oldState,
                videoJsOptions: {
                    autoplay: true,
                    controls: false,
                    responsive: true,
                    isFullscreen: false,
                    fluid: true,
                    sources: [{
                        src: url,
                        type: 'video/mp4'
                    }]
                }
            }));

        }
    };


    const handleSeekToggle = (event) => {
        closeSocket();

        openSocket().then((client) => {
            sendMessageSocket(client, token);

        }).catch((err) => {

        });

        let object = square_ref.current.getBoundingClientRect();
        let left = object.left;
        let width = object.width;
        let postion = event.clientX - left;

        if (state.item_type === 0) {
            audio.currentTime = (postion * audio.duration) / (width);
        } else if (state.item_type === 1) {
            if (!playerRef.current) {
                return;
            }

            playerRef.current.currentTime((postion * playerRef.current.duration()) / (width))
        }
    };

    const handlePlayForward = (event) => {
        closeSocket();

        openSocket().then((client) => {
            sendMessageSocket(client, token);
        }).catch((err) => {

        });

        if (state.item_type === 0) {
            audio.currentTime += 30;
        } else {
            if (!playerRef.current) {
                return;
            }

            let tempCurrentTime = playerRef.current.currentTime() + 30;

            playerRef.current.currentTime(tempCurrentTime)
        }
    };

    const handlePlayBack = (event) => {
        closeSocket();

        openSocket().then((client) => {
            sendMessageSocket(client, token);

        }).catch((err) => {

        });

        if (state.item_type === 0) {
            audio.currentTime -= 15;
        } else {
            if (!playerRef.current) {
                return;
            }

            let tempCurrentTime = playerRef.current.currentTime() - 15;

            playerRef.current.currentTime(tempCurrentTime)
        }

    };

    let fullTime = 0;

    if (duration)
        fullTime = duration;

    if (state.name === "" || state.url === "" || !token) {
        return (<></>);
    }

    return (
        <>

            <footer className="footer">
                <div>
                    <nav className="navbar navbar-expand-lg navbar-div footer-nav"
                         style={
                             state.item_type === 0 ? {
                                 "padding": "18px 10px"
                             } : {}
                         }>
                        {
                            state.item_type === 1 &&
                            <a className="player-img order-1" href="#0">

                                <>
                                    <React.Fragment>
                                        <ModalVideo channel="custom" isOpen={state.video_full_screen}
                                                    url={state.videoJsOptions.sources[0].src}
                                                    onClose={() => setState({video_full_screen: false})}/>
                                    </React.Fragment>
                                    <div onClick={handleFullScreen}>
                                        <VideoJS options={state.videoJsOptions} onReady={handlePlayerReady}/>
                                    </div>
                                </>
                            </a>
                        }
                        <p className="player-title order-2">
                            {state.name}
                        </p>
                        <div className="player-progress-bar-div order-sm-3 order-3">
							<span className="full-time">
							{
                                new Date(fullTime * 1000).toISOString().substr(11, 8).replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
                            }
							</span>
                            <div className="player-progress-bar-back" ref={square_ref}>
                                {
                                    state.item_type === 0 &&
                                    <Progress type={0} width={100 * currentTime / audio.duration}/>
                                }
                                {
                                    state.item_type === 1 && playerRef.current &&
                                    <Progress type={0} width={100 * currentTime / playerRef.current.duration()}/>
                                }
                            </div>

                            <span className="play-time">
								{new Date(parseInt(currentTime) * 1000).toISOString().substr(11, 8).replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
							</span>
                        </div>
                        {/*<a className="player-sound order-sm-4 order-4" href="#0" onClick={setVolumeStatusState}>*/}
                        {/*	{*/}
                        {/*		volumeStatus && <img className="ic-player-sound" src={playerSound} alt=""/>*/}
                        {/*	}*/}
                        {/*	{*/}
                        {/*		!volumeStatus && <img className="ic-player-sound" src={playerSoundZero} alt=""/>*/}
                        {/*	}*/}
                        {/*</a>*/}
                        <div className="arrow-parent order-sm-5 order-6">
                            <select className="player-rate order-sm-4 order-7"
                                    onChange={(e) => setMediaRateState(e.target.value)}>
                                <option value="1">1x</option>
                                <option value="1.25">1.25x</option>
                                <option value="1.5">1.5x</option>
                                <option value="1.75">1.75x</option>
                                <option value="2">2x</option>
                            </select>
                            <a className="player-forward order-sm-5 order-4" onClick={handlePlayForward} style={{
                                "backgroundImage": playForward
                            }} href="#0">
                                ۳۰
                            </a>
                            <a className="play-pause order-sm-6 order-5" href="#0" onClick={toggle}>
                                {
                                    isPlaying && <img className="ic-play-pause" src={pauseImg} alt=""/>
                                }
                                {
                                    !isPlaying && <img className="ic-play-pause" src={playImg} alt=""/>
                                }
                            </a>
                            <a className="player-back order-sm-7 order-6" onClick={handlePlayBack} style={{
                                "backgroundImage": playBack
                            }} href="#0">
                                ۱۵
                            </a>
                        </div>
                    </nav>
                </div>
            </footer>
        </>
    );
};

export default Footer;
